// extracted by mini-css-extract-plugin
module.exports = {"card":"FlashCard_card__wc2g4","flipped":"FlashCard_flipped__grVep","cardSide":"FlashCard_cardSide__EcWBR","front":"FlashCard_front__5yEO_","back":"FlashCard_back__gIFVN"};